import { Pipe, PipeTransform } from '@angular/core';
import { RefreshFileService } from 'app/main/signing-pages/helpers/refresh-file.service';
import { lastValueFrom } from 'rxjs';

@Pipe({
  name: 'signingPageImage'
})
export class SigningPageImagePipe implements PipeTransform {
    constructor(private refreshFileService:RefreshFileService) { }
  async transform(url:string, recipientRole:number, role_id:number = 0, isEForm:boolean = false){
    const image:Blob = await lastValueFrom(this.refreshFileService.refreshImage(url, recipientRole, role_id, isEForm));
    if(image){
      return window.URL.createObjectURL(image);
    }
    return '';
  }

}
